/**
 * Translation resources. `en.json` / `nl.json` hold shared strings; each feature
 * area owns `locales/<lang>/<feature>.json`, exposed under the `<feature>` key
 * (e.g. `t("studio.agents.title")`).
 */

import enChat from "./en/chat.json"
import enInsights from "./en/insights.json"
import enKnowledge from "./en/knowledge.json"
import enStudio from "./en/studio.json"
import enTasks from "./en/tasks.json"
import enWorkplace from "./en/workplace.json"
import enCore from "./en.json"
import nlChat from "./nl/chat.json"
import nlInsights from "./nl/insights.json"
import nlKnowledge from "./nl/knowledge.json"
import nlStudio from "./nl/studio.json"
import nlTasks from "./nl/tasks.json"
import nlWorkplace from "./nl/workplace.json"
import nlCore from "./nl.json"

export const en = {
  ...enCore,
  studio: enStudio,
  chat: enChat,
  workplace: enWorkplace,
  tasks: enTasks,
  knowledge: enKnowledge,
  insights: enInsights,
}

export const nl: typeof en = {
  ...nlCore,
  studio: nlStudio,
  chat: nlChat,
  workplace: nlWorkplace,
  tasks: nlTasks,
  knowledge: nlKnowledge,
  insights: nlInsights,
} as typeof en
